<script>
  import { onMount, beforeUpdate } from 'svelte'
  import FundipStick from './FundipStick.svelte'
  
  export let sticks = []
  // undefined/base, red or duotone
  export let variant = undefined
  export let prefix = ''
  export let suffix = ''

  let containerWidth

  let maxValue = 100
  let baseAnimationDelay = 250

  function getMaxValue() {
    sticks.forEach((stick)=>{
      if(Number(stick.value) > maxValue) {
        maxValue = Number(stick.value)
      }
    })
  }
  // $:console.log('prefix fundip', prefix)
  // onMount(()=>{getMaxValue()})
  beforeUpdate(()=>{ getMaxValue() })
</script>

<div class="fundip-sticks{ containerWidth < 590 || variant == 'duotone' ? ' rotate' : '' }" bind:clientWidth={ containerWidth }>
  {#each sticks as stick, i }
    <FundipStick 
      max={maxValue} 
      value={stick.value}
      label={stick.label} 
      animationDelay={baseAnimationDelay + (i * 250 )} 
      variant={ variant == 'duotone' ? (i == 0 ? 'gray' : 'red') : variant } 
      rotate={ containerWidth < 590 || variant == 'duotone' ? true : false } 
      prefix={ prefix }
      suffix={ suffix }
      isDecorative={ variant == 'duotone' ? true : false }
      index={ i }
      />
  { /each }
</div>

<style lang="postcss">
  .fundip-sticks {
    min-height: 500px;
    display: flex;
    width: 100%;
    justify-content: space-evenly;
    gap: 2em;
    align-content: flex-end;
  }

  .fundip-sticks.rotate {
    min-height: unset;
    flex-direction: column;
    justify-content: center;
  }
</style>